const colorClasses = {
  blue: 'bg-blue-500',
  green: 'bg-green-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
  purple: 'bg-purple-500',
};

export default function ProgressBar({ value = 0, color = 'blue' }) {
  const barColor = colorClasses[color] || colorClasses.blue;
  const clampedValue = Math.min(Math.max(value, 0), 100);

  return (
    <div className="w-full h-1 bg-[#1e2235] rounded-full overflow-hidden">
      <div
        className={`h-full ${barColor} transition-all duration-300`}
        style={{ width: `${clampedValue}%` }}
      />
    </div>
  );
}
